














































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {asyncScheduler, combineLatest, from, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import DataTable from '@/components/common/DataTable.vue';
import DataFilter from '@/components/common/DataFilter.vue';
import UserLinks from '@/components/common/UserLinks.vue';
import RandomSign from '@/components/common/RandomSign.vue';
import {tournamentsApi} from '@/api/TournamentsApi';
import {filterMatchColumns} from '@/helpers';
import {generateLangSubscriptions, observeFieldAsUIInput, observeProp} from '@/components/observe';
import FlagIcon from '@/components/common/FlagIcon.vue';
import FractionIcon from '@/components/common/FractionIcon.vue';
import HeroIcon from '@/components/common/HeroIcon.vue';
import GameResultIcon from '@/components/common/GameResultIcon.vue';

@Component<UnconfirmedReports>({
  components: {
    GameResultIcon,
    HeroIcon,
    FractionIcon,
    FlagIcon,
    RandomSign,
    UserLinks,
    DataFilter,
    DataTable,
  },
  subscriptions() {
    return Object.assign(generateLangSubscriptions(observeProp<string>(this, 'lang')), {
      userInfo: from(tournamentsApi.getCurrentTournamentUserInfo$(), asyncScheduler),
      unconfirmedReports: combineLatest(
        observeProp(this, 'reports'),
        observeFieldAsUIInput(this, 'unconfirmedReportsFilter'),
      ).pipe(
        switchMap(([r, rFilter]: any) => of(r.filter((x: any) => this.filterMatch(x, rFilter)))),
      ),
    });
  },
})
export default class UnconfirmedReports extends Vue {
  public unconfirmedReportsFilter = '';
  public unconfirmedReportsColumns = [
    {name: 'date', title: 'game_date', width: '6.6%'},
    {name: 'player', title: 'player', width: '6.6%'},
    {name: 'player_color', title: 'color', width: '6.6%'},
    {name: 'player_fraction', title: 'fraction', width: '6.6%'},
    {name: 'player_start_hero', title: 'start_hero', width: '6.6%'},
    {name: 'player_main_hero', title: 'main_hero', width: '6.6%'},
    {name: 'result', title: 'result', width: '6.6%'},
    {name: 'rival', title: 'rival', width: '6.6%'},
    {name: 'rival_color', title: 'color', width: '5.5%'},
    {name: 'rival_fraction', title: 'fraction', width: '6.6%'},
    {name: 'rival_start_hero', title: 'start_hero', width: '6.6%'},
    {name: 'rival_main_hero', title: 'main_hero', width: '6.6%'},
    {name: 'template', title: 'template', width: '6.6%'},
    {name: 'time', title: 'time', width: '6.6%'},
    {name: 'confirm_link', title: 'confirm_link', width: '6.6%'},
  ];

  @Prop() public lang!: string;
  @Prop() public reports!: any[];

  public filterMatch(report: any, reportFilter: any) {
    return filterMatchColumns(report, reportFilter, [
      'game_date',
      'player_fraction',
      'player_start_hero',
      'player_main_hero',
      'result',
      'rival_fraction',
      'rival_start_hero',
      'rival_main_hero',
      'template',
      'game_time',
      'player1_username',
      'player2_username',
    ]);
  }
}
